import { TrendingUp, AlertTriangle, Clock, Target } from "lucide-react";
import { AIInsight } from "@/components/stats/AIInsightsCard";

type StatsData = {
  totalPatients: number;
  totalRecords: number;
  totalDocuments: number;
  criticalAlerts: number;
  patientGrowth?: number;
  recordGrowth?: number;
  documentGrowth?: number;
};

export const generateInsights = (data: StatsData): AIInsight[] => {
  const insights: AIInsight[] = [];

  // Crescimento de pacientes
  if (data.patientGrowth && data.patientGrowth > 20) {
    insights.push({
      icon: TrendingUp,
      title: `Crescimento de ${data.patientGrowth}% em pacientes`,
      description: "Sua base de pacientes está crescendo rapidamente!",
      type: "success"
    });
  } else if (data.totalPatients > 0) {
    insights.push({
      icon: Target,
      title: `${data.totalPatients} pacientes cadastrados`,
      description: "Continue crescendo sua base de pacientes",
      type: "info"
    });
  }

  // Alertas críticos
  if (data.criticalAlerts > 0) {
    insights.push({
      icon: AlertTriangle,
      title: `${data.criticalAlerts} alertas críticos`,
      description: "Pacientes que requerem atenção imediata",
      type: "warning"
    });
  }

  // Atividade de documentos
  if (data.documentGrowth && data.documentGrowth > 30) {
    insights.push({
      icon: TrendingUp,
      title: `Processamento de documentos aumentou ${data.documentGrowth}%`,
      description: "Você está processando muito mais documentos que antes",
      type: "success"
    });
  } else if (data.totalDocuments > 0) {
    insights.push({
      icon: Clock,
      title: `${data.totalDocuments} documentos processados`,
      description: "Mantenha seus registros sempre atualizados",
      type: "info"
    });
  }

  // Insights de registros
  if (data.totalRecords > 100) {
    insights.push({
      icon: Target,
      title: "Base de dados robusta",
      description: `${data.totalRecords} registros de saúde coletados`,
      type: "success"
    });
  }

  // Se não há insights, adicionar mensagem padrão
  if (insights.length === 0) {
    insights.push({
      icon: Clock,
      title: "Comece a adicionar dados",
      description: "Cadastre pacientes e processe documentos para ver insights",
      type: "info"
    });
  }

  return insights.slice(0, 4); // Máximo de 4 insights
};
